module.exports = __webpack_public_path__ + "static/media/flight-delay-assistance.b69f3b20.svg";